import { Controller } from "stimulus"
import PrescreenNotificationModule from "./shared_modules/prescreen_notification_module.js"

export default class extends Controller {
  static values = {
    notice: String,
    alert: String
  }

  connect() {
    this.notifications = new PrescreenNotificationModule()

    if (this.noticeValue) {
      this.notifications.success(this.noticeValue)
    }

    if (this.alertValue) {
      this.notifications.error(this.alertValue)
    }
  }
}
